import React, { PureComponent } from 'react'
import JSONEditor from 'jsoneditor'
import JsonEditorStyled from './styled'

class JsonEditor extends PureComponent {
  componentDidMount() {
    this.initJsonEditor()
  }

  componentDidUpdate() {
    if (this.jsoneditor) {
      this.jsoneditor.set(this.props.value)
    }
  }

  componentWillUnmount() {
    if (this.jsoneditor) {
      this.jsoneditor.destroy()
    }
  }

  onChange = () => {
    const value = this.jsoneditor.get()
    this.props.onChange(value)
  }

  initJsonEditor = () => {
    const options = {
      mode: this.props.mode || 'code',
      history: true,
      onChange: this.onChange,
    }

    this.jsoneditor = new JSONEditor(this.container, options)
    this.jsoneditor.set(this.props.value)
  }

  render() {
    return (
      <JsonEditorStyled
        ref={(elem) => {
          this.container = elem
        }}
      />
    )
  }
}
export default JsonEditor
